import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import DesignerNavigation from './DesignerNavigation';
import styles from './DesignerNavigation.styles';

export default compose(
  withRouter,
  withStyles(styles),
)(DesignerNavigation);
